module.exports = __webpack_public_path__ + "static/img/5areaA_5.8e99f2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/5areaA_5.png
// module id = 905
// module chunks = 1